import { ISVG } from "../UrlIcon";

export const HorizontalEndIcon = ({ className }: ISVG) => {
    return (
        <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" className={`${className}`}>
            <g clipPath="url(#a)">
                <path d="M.625 3.125h18.75a.625.625 0 1 0 0-1.25H.625a.625.625 0 1 0 0 1.25ZM19.375 6.875H6.25a.625.625 0 1 0 0 1.25h13.125a.625.625 0 1 0 0-1.25ZM19.375 11.875H.625a.625.625 0 1 0 0 1.25h18.75a.625.625 0 0 0 0-1.25ZM19.375 16.875h-8.438a.625.625 0 1 0 0 1.25h8.438a.625.625 0 0 0 0-1.25Z" />
            </g>
            <defs>
                <clipPath id="a">
                    <path fill="#fff" d="M0 0h20v20H0z" />
                </clipPath>
            </defs>
        </svg>
    );
};
